import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { FileIcon } from "../../common/components/primitives/fileicon/index.jsx";
import { OverflowText } from "../overflowtext/index.jsx";
import {
  ICON_SIZE,
  ICON_STROKE,
  KF_ICONS,
  ICON_PADDING,
  ICON_BACKGROUND,
  KfIcon
} from "@widgets/common/components/primitives/kf_icon/index.jsx";

import styles from "./filethumb.css";

/**
 * Displays file thumbnail.
 */

export function FileThumb(props) {
  const {
    type,
    name,
    readonly,
    thumbUrl,
    onClick,
    onClose,
    disabled,
    className
  } = props;
  return (
    <div
      className={`${styles.filethumb} ${readonly ? styles.readonly : ""} ${
        disabled ? styles.disabled : ""
      } ${className}`}
      onClick={onClick}
      tabIndex={0}
      data-component="filethumb"
    >
      <div className={styles.thumb}>
        {thumbUrl && (
          <img loading="lazy" src={thumbUrl} alt={`Thumbnail of ${name}`} />
        )}
        {!thumbUrl && <FileIcon type={type} />}
      </div>
      <div className={styles.namecontainer}>
        <OverflowText
          line={2}
          className={`${readonly ? "base" : ""} ${styles.name}`}
        >
          {name}
        </OverflowText>
      </div>
      {onClose && (
        <div className={styles.close}>
          <KfIcon
            icon={KF_ICONS.CLOSE}
            stroke={ICON_STROKE.THIN}
            size={ICON_SIZE.SIZE_8}
            // hoverType={ICON_HOVER_TYPE.LIGHT_GRAY}
            padding={ICON_PADDING.PADDING_4}
            backgroundType={ICON_BACKGROUND.SOLID}
            onClick={onClose}
            className={`${styles.closeIcon}`}
          />
        </div>
      )}
    </div>
  );
}

FileThumb.propTypes = {
  /**
   * file type pdf, png ...
   */
  type: PropTypes.string.isRequired,
  /**
   * name of the file
   */
  name: PropTypes.string.isRequired,
  /**
   * user can able to just read permission
   */
  readonly: PropTypes.bool,
  /**
   * user cannot able to do any action on this component
   */
  disabled: PropTypes.bool,
  /**
   * url of the file
   */
  thumbUrl: PropTypes.string.isRequired,
  /**
   * will get trigger if user click on file
   */
  onClick: PropTypes.func,
  /**
   * will get trigger if user close the file
   */
  onClose: PropTypes.func,
  /**
   * styles can be override using this prop
   */
  className: PropTypes.string
};
